export default __webpack_public_path__ + "static/media/post5.f8029153.jpg";